import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Button } from "../../components/ui/button";
import CajaCategoriaForm from "../../components/modals/CajaCategoriaForm";
import { Plus, Pencil } from "lucide-react";

const CajaCategoriasPage = () => {
  const [categorias, setCategorias] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selected, setSelected] = useState(null);

  const token = localStorage.getItem("token");
  const API_URL = process.env.REACT_APP_API_URL + "/caja";

  const fetchCategorias = async () => {
    try {
      const res = await axios.get(`${API_URL}/categorias`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCategorias(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Error al cargar categorías");
    }
  };

  useEffect(() => { fetchCategorias(); }, []); // eslint-disable-line

  const handleSave = async (formData) => {
    try {
      if (selected) {
        await axios.put(`${API_URL}/categorias/${selected.codigo}`, formData, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success("Categoría actualizada correctamente");
      } else {
        await axios.post(`${API_URL}/categorias`, formData, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success("Categoría creada correctamente");
      }
      setShowModal(false);
      fetchCategorias();
    } catch (err) {
      const msg = err.response?.data?.error || err.message || "Error inesperado";
      toast.error(msg);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-sm font-semibold text-gray-700">Categorías de movimientos de caja</h3>
        <Button onClick={() => { setSelected(null); setShowModal(true); }} className="gap-2">
          <Plus className="h-4 w-4" /> Nueva categoría
        </Button>
      </div>

      <div className="overflow-x-auto rounded-xl border border-brand-100">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="bg-brand-gradient text-white">
              {["Código", "Nombre", "Tipo", "Estado", ""].map((h, i) => (
                <th key={i} className={`px-4 py-3 text-xs font-semibold uppercase tracking-wider ${i === 4 ? "text-right" : "text-left"}`}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-brand-50 bg-white">
            {categorias.length > 0 ? categorias.map((c, i) => (
              <tr key={c.codigo} className={`transition-colors ${i % 2 === 0 ? "bg-white" : "bg-brand-50/30"} hover:bg-brand-50`}>
                <td className="px-4 py-3">
                  <span className="font-mono text-xs bg-brand-100 text-brand-700 px-2 py-0.5 rounded font-semibold">{c.codigo}</span>
                </td>
                <td className="px-4 py-3 text-gray-800 font-medium">{c.detalle}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${c.tipo === "INGRESO" ? "bg-emerald-100 text-emerald-700" : "bg-red-100 text-red-700"}`}>
                    {c.tipo}
                  </span>
                </td>
                <td className="px-4 py-3 text-gray-600">{c.activo ? "Activa" : "Inactiva"}</td>
                <td className="px-4 py-3 text-right">
                  <Button variant="outline" size="sm" onClick={() => { setSelected(c); setShowModal(true); }} className="gap-1">
                    <Pencil className="h-3 w-3" /> Editar
                  </Button>
                </td>
              </tr>
            )) : (
              <tr><td colSpan="5" className="py-8 text-center text-gray-400 text-sm italic">No hay categorías</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {showModal && (
        <CajaCategoriaForm categoria={selected} onClose={() => setShowModal(false)} onSave={handleSave} />
      )}
    </div>
  );
};

export default CajaCategoriasPage;
